<h5>Tarefas para recuperações de crédito</h5>

<div class="container">
  <div ngbAccordion>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title">Criar Recuperação de Crédito</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
            <div class="col-md-3">
              <label for="idOperacaoCredito1">Id Operação de Crédito: </label>
              <input type="text" id="idOperacaoCredito1" class="form-control" bnMask="INTEIRO"
                [(ngModel)]="idOperacaoCredito1">
            </div>

            <div class="col-md-3">
              <label>Data Recuperação:</label>
              <bn-datepicker name="dataRecuperacao1" idInput="dataRecuperacao1" ngDefaultControl
                [(ngModel)]="dataRecuperacao1">
              </bn-datepicker>
            </div>

            <div class="col-md-3">
              <label for="valorRecuperacao">Valor Recuperação: </label>
              <input type="text" id="valorRecuperacao" class="form-control" bnMask="DECIMAL" casasDecimais="2"
                [(ngModel)]="valorRecuperacao">
            </div>
          </div>

          <div class="row">
            <div class="submit col-auto">
              <button type="button" class="btn btn-success no-margin" (click)="criaRecuperacaoCredito()">Criar</button>
            </div>
            <div class="submit col-auto">
              <button type="button" class="btn btn-light" (click)="limparCriaRecuperacaoCredito()">Limpar</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title2">Alterar Estado Recuperação de Crédito</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
            <div class="col-md-3">
              <label for="idRecuperacao1">Id Recuperação: </label>
              <input type="text" id="idRecuperacao1" class="form-control" bnMask="INTEIRO"
                [(ngModel)]="idRecuperacao1">
            </div>

            <div class="col-md-3">
              <label for="idEstado">Estado:</label>
              <select id="idEstado" class="form-select" [(ngModel)]="idEstado">
                <option [ngValue]=null>Todos</option>
                <option [ngValue]="estado.id" *ngFor="let estado of estados">
                  {{estado.nome}}
                </option>
              </select>
            </div>

          </div>

          <div class="row">
            <div class="submit col-auto">
              <button type="button" class="btn btn-success no-margin"
                (click)="alteraEstadoRecuperacaoCredito()">Alterar</button>
            </div>
            <div class="submit col-auto">
              <button type="button" class="btn btn-light"
                (click)="limparAlteraEstadoRecuperacaoCredito()">Limpar</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title3">Remover recuperação de crédito</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
            <div class="col-md-3">
              <label for="idRecuperacao2">Id Recuperação: </label>
              <input type="text" id="idRecuperacao2" class="form-control" bnMask="INTEIRO"
                [(ngModel)]="idRecuperacao2">
            </div>

          </div>

          <div class="row">
            <div class="submit col-auto">
              <button type="button" class="btn btn-success no-margin"
                (click)="abrirModal('Modal com body sendo uma template', 'lg', true, true);">Remover</button>
              <ng-template #body>Esta tarefa remove apenas o registro de recuperação da base do portal do FG2. Caso já
                tenha havido baixa de cobrança com registro de movimentos no RCC, esses movimentos
                devem ser manualmente apagados pela ATI. Para conferir os movimentos atualmente presentes, utilizar a
                tarefa de consulta de movimentos no menu Contrato SCC.
                <br><br><b>Deseja prosseguir com a remoção da recuperação de crédito?</b>
              </ng-template>
              <ng-template #meuid>
                <button class="btn btn-success" (click)="removeRecuperacaoCredito()">Sim</button>
                <button class="btn btn-danger" (click)="close()">Não</button>
              </ng-template>
            </div>
            <div class="submit col-auto">
              <button type="button" class="btn btn-light" (click)="limparRemoveRecuperacaoCredito()">Limpar</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title4">Remover todas as recuperações de crédito</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
            <div class="col-md-3">
              <label for="idOperacao">Id Operação: </label>
              <input type="text" id="idOperacao" class="form-control" bnMask="INTEIRO" [(ngModel)]="idOperacao">
            </div>
          </div>

          <div class="row">
            <div class="submit col-auto">
              <button type="button" class="btn btn-success no-margin"
                (click)="removeTodasAsRecuperacoesCredito()">Remover</button>
            </div>
            <div class="submit col-auto">
              <button type="button" class="btn btn-light"
                (click)="limparRemoveTodasAsRecuperacoesCredito()">Limpar</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title5">Processar recuperação de crédito</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
            <div class="col-md-3">
              <label for="idRecuperacao3">Id Recuperação</label>
              <input type="text" id="idRecuperacao3" class="form-control" bnMask="INTEIRO"
                [(ngModel)]="idRecuperacao3">
            </div>
          </div>

          <div class="row">
            <div class="submit col-auto">
              <button type="button" class="btn btn-success no-margin"
                (click)="processaRecuperacaoCredito()">Processar</button>
            </div>
            <div class="submit col-auto">
              <button type="button" class="btn btn-light"
                (click)="limparProcessaRecuperacaoCredito()">Limpar</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title6">Simular conclusão de recuperação de crédito</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
            <div class="col-md-3">
              <label for="idOperacaoCredito2">Id Operação de Crédito: </label>
              <input type="text" id="idOperacaoCredito2" class="form-control" bnMask="INTEIRO"
                [(ngModel)]="idOperacaoCredito2">
            </div>

            <div class="col-md-3">
              <label>Data Recuperação:</label>
              <bn-datepicker name="dataRecuperacao2" idInput="dataRecuperacao2" ngDefaultControl
                [(ngModel)]="dataRecuperacao2" [minDate]="data">
              </bn-datepicker>
            </div>
          </div>

          <div class="row">
            <div class="submit col-auto">
              <button type="button" class="btn btn-success no-margin"
                (click)="simulaRecuperacaoCredito()">Simular</button>
            </div>
            <div class="submit col-auto">
              <button type="button" class="btn btn-light" (click)="limparSimulaRecuperacaoCredito()">Limpar</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  </div>
</div>

